import * as React from 'react';
import { css, StyleDeclarationValue } from 'aphrodite';
import { IStackedBarChart } from '../../../../models/Charts';
import { styleSheet } from './styles';

interface IProps {
	className?: string;
	chart: IStackedBarChart;
	height?: number;
	onBarClick?(data: unknown): void;
	onRenderLoadingPlaceholder?(): React.ReactNode;
	styles?: StyleDeclarationValue[];
}

const LazyBarchart = React.lazy(() => import(/* webpackChunkName: "barchart" */ './barchart'));

export function StackedBarChart({ className, styles, chart, height, onBarClick, onRenderLoadingPlaceholder }: IProps) {
	return (
		<div className={`${css(styleSheet.container, ...(styles || []))} stacked-bar-chart ${className || ''}`}>
			<React.Suspense fallback={onRenderLoadingPlaceholder?.() || null}>
				<LazyBarchart chart={chart} height={height} onBarClick={onBarClick} />
			</React.Suspense>
		</div>
	);
}
